/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'

import { IconArrowDown } from 'components/Icons'

export interface MenuProps {
  id?: string
  name?: string
  className?: string
  children: React.ReactNode | React.ReactNode[]
  onChange?: (key: string) => void
  defaultOpenKeys?: string[]
  defaultSelected?: string
}

export interface MenuItemProps {
  className?: string
  children: React.ReactNode
  title?: string
  id: string
  onClick?: (id: string) => void
  defaultOpenKeys?: string[]
}

export interface SubmenuProps extends MenuItemProps {
  id: string
  // FIXME: refactor by recusive function
  selected?: string
  onSelected?: (id: string) => void
  onChange?: (id: string) => void
}

export const MenuItem: React.FC<MenuItemProps> = (props: MenuItemProps) => {
  const { id, className, children, onClick } = props

  return (
    <li
      id={id}
      className={clsx('menu__item', className)}
      onClick={() => onClick && onClick(id)}
      data-testid='menu-item'
    >
      <span className='menu__item__space'>{children}</span>
    </li>
  )
}

export const Submenu: React.FC<SubmenuProps> = (props: SubmenuProps) => {
  const {
    id,
    children,
    title,
    selected = '',
    onSelected,
    onChange,
    defaultOpenKeys,
  } = props
  const openSubmenu = Boolean(defaultOpenKeys?.includes(id))
  const [open, setOpen] = useState<boolean>(openSubmenu)

  const items = React.Children.toArray(children)
  // FIXME: fix React child type
  const itemIds = items.map((child: any) => child.props.id)
  const hasActiveSubmenu = itemIds.includes(selected)

  const _handleToggle = () => {
    setOpen((prev) => !prev)
  }

  const _handleClick = (id: string) => {
    if (!(onChange && onSelected)) {
      return
    }

    onChange(id)
    onSelected(id)
  }

  return (
    <MenuItem
      id={id}
      className={clsx('menu__submenu__item', open && 'menu__submenu--open')}
    >
      <label
        className={clsx(
          'menu__submenu__title',
          hasActiveSubmenu && 'menu__submenu__title--active',
        )}
        onClick={() => _handleToggle()}
        data-testid='menu-submenu-label'
      >
        <span
          className={clsx('menu__submenu__title', 'menu__item__space')}
          data-testid='menu-submenu-title'
        >
          {title}
        </span>
        <span className='menu__submenu__arrow'>
          <IconArrowDown variants='xs' />
        </span>
      </label>
      <ul className={clsx('menu__submenu')}>
        {/* FIXME: fix React child type */}
        {items.map((child: any) => {
          return React.cloneElement(child, {
            className: clsx(
              child.props.id === selected && 'menu__submenu__item--selected',
            ),
            onClick: (_id: string) => _handleClick(_id),
          })
        })}
      </ul>
    </MenuItem>
  )
}

/**
 * TODO:
 * - [] use Provider implement
 * - [] support submenu recusive
 * - [] unused any type
 */
const Menu: React.FC<MenuProps> = (props: MenuProps) => {
  const {
    className,
    children,
    onChange,
    defaultSelected = '',
    defaultOpenKeys = [],
  } = props
  const [selected, setSelected] = useState<string>(defaultSelected)
  const cn = clsx('menu', className)
  const items = React.Children.toArray(children)

  const _handleClick = (id: string) => {
    if (onChange) {
      onChange(id)
    }
  }
  useEffect(() => {
    if (window.location.pathname) {
      setSelected(window.location.pathname.split('/')[1])
    }
  }, [])

  return (
    <aside className={cn}>
      <ul className='menu__list'>
        {/* FIXME: fix React child type */}
        {items.map((child: any) => {
          return React.cloneElement(child, {
            className: clsx(
              child.props.id === selected && 'menu__item--selected',
            ),
            onClick: (_id: string) => _handleClick(_id),
            selected,
            onChange,
            defaultOpenKeys,
          })
        })}
      </ul>
    </aside>
  )
}

export default Menu
